import {
  Box,
  Link,
  Typography,
  Dialog,
  DialogContent,
  Grid,
  DialogTitle,
  IconButton,
  TextareaAutosize,
  FormControl,
  Select,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./scMembers.module.scss";
import constants from "../../config/constants.json";
import Pagination from "../common/pagination/pagination";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCheckbox,
  CustomInputLabel,
  CustomMenuItem,
} from "../common/StyledComponents/StyledFields";
import CloseIcon from "@mui/icons-material/Close";
import { BeatLoader, BounceLoader, ClipLoader } from "react-spinners";
import {
  apiRequest,
  catchErrorMessageHandler,
  getDevoteeAddress,
} from "../../infrastructure/backendService";
import ErrorPopup from "../common/ErrorPopup";
import toast, { Toaster } from "react-hot-toast";
import apiPath from "../../config/apiPaths.json";
import ToastComponent from "../common/toastComponent";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { isNil } from "lodash";

interface NewSCMProps {
  updateSearchItems: any[]; // Replace any with your actual type
  totalRecords: number;
  pageNumber: number;
  setPageNumber: React.Dispatch<React.SetStateAction<number>>;
  searchDataApi: () => void;
  showTableComponent: boolean;
}

const UpdateScmStatusComponent = (props: NewSCMProps) => {
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [newScmDetails, setNewScmDetails] = useState<any[]>([]);
  const [selectedUsernames, setSelectedUsernames] = useState<any[]>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [statusList, setStatusList] = useState<any[]>([]);
  const [userDetails, setUserDetails] = useState<any[]>([]);
  const [confirmedUser, setConfirmedUser] = useState("");
  const [confirmedStatus, setConfirmedStatus] = useState("");
  const [searchButton, setSearchButton] = useState<boolean>(true);
  const [loading, setLoading] = useState(false);
  const [loadingBounce, setLoadingBounce] = useState(false);
  const [userDetailsList, setUserDetailsList] = useState<any>({});
  const [userDetailsDevoteeCategoryList, setUserDetailsDevoteeCategoryList] = useState<any>([]);
  const [selectedUserName, setSelectedUserName] = useState("");
  const [openUserDetailsDialog, setOpenUserDetailsDialog] = useState(false);

  useEffect(() => {
    if ((statusList?.length > 0, props?.updateSearchItems?.length > 0)) {
      const getStatusId = (name: string) => {
        return statusList?.find((status: any) => status?.name === name);
      };

      let data: any = [];

      props?.updateSearchItems?.forEach((eachItem: any) => {
        if (
          eachItem.categoryName !== null &&
          eachItem.categoryName !== "Steering Committee Member"
        ) {
          data.push({
            username: eachItem?.username,
            status: getStatusId(eachItem?.categoryName)?.id,
            ...eachItem,
          });
        }
      });
      setUserDetails(data);
    }
  }, [props?.updateSearchItems, statusList]);

  const handleDropdownChange = (value: number, username: string) => {
    let data = userDetails?.map((eachUser: any) => {
      if (eachUser?.username === username) {
        return { ...eachUser, status: value };
      } else {
        return eachUser;
      }
    });
    setUserDetails(data);
  };

  const handleSuccessDialogClose = () => {
    setOpenSuccessDialog(false);
  };

  const handleConfirm = () => {
    ConfirmUpdateApiCall();
  };

  const ConfirmUpdateApiCall = () => {
    setLoading(true);
    setSelectedRows([]);
    const filteredData = userDetails?.find(
      (each) => each?.userCategoryId === selectedUsernames[0]
    )
    const reqBody = {
      username: filteredData?.username,
      categoryId: filteredData?.status,
      id: filteredData?.userCategoryId,
      defaultCategory: false,
    };
    apiRequest({
      method: "PUT",
      endpoint: apiPath.scmUpdateCategoryApi,
      includeToken: true,
      body: JSON.stringify(reqBody),
      params: {
        scm: true,
      },
    })
      .then((res) => {
        setLoading(false);
        setOpenConfirmationDialog(false);
        setOpenSuccessDialog(true);
        setConfirmedUser(res.data.username);
        setSearchButton(true);

        let confirmedStatus = res.data.categoryId;
        if (confirmedStatus === 79) {
          setConfirmedStatus("Active");
        }
        if (confirmedStatus === 80) {
          setConfirmedStatus("Inactive");
        }
        if (confirmedStatus === 99) {
          setConfirmedStatus("Deceased");
        }
        if (confirmedStatus === 100) {
          setConfirmedStatus("New");
        }
        if (confirmedStatus === 102) {
          setConfirmedStatus("Resigned");
        }
        props.searchDataApi();
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };
  useEffect(() => {
    getUserCategoryApi();
  }, []);

  const getUserCategoryApi = () => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.scmGetCatergoriesApi,
      includeToken: true,
      params: {
        scm: true,
      },
    })
      .then((res) => {
        setStatusList(res.data.content);
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const userDetailsApiCall = (row: any) => {
    setLoadingBounce(true);
    apiRequest({
      method: "GET",
      endpoint: `${apiPath.devoteeServiceUserDetailsApi}/${row.username}`,
      includeToken: true,
    })
      .then((res) => {
        console.log(res.data, "res.dataaaa");
        setUserDetailsList(res?.data);
        setUserDetailsDevoteeCategoryList(res?.data?.categoryNames)
        setLoadingBounce(false);
      })
      .catch((err) => {
        console.log(err);
        setLoadingBounce(false);
      });
  };

  const handleUserDetailsDialogClose = () => {
    setOpenUserDetailsDialog(false);
  };

  const handleDetailsClick = (item: any) => {
    setSelectedUserName(item.username);
    setOpenUserDetailsDialog(true);
    userDetailsApiCall(item);
    console.log(item, "rowwww")
  }

  const selectStatusDropdown = (
    status: any,
    username: string
  ): React.ReactElement => {
    return (
      <FormControl className={styles.moveToDropdown}>
        <Select
          sx={{
            background: "#fff",
            padding: "2px",
            height: "30px",
            width: "325px",
            fontSize: "13px",
          }}
          IconComponent={KeyboardArrowDownIcon}
          id="grouped-select"
          value={status}
          onChange={(e) => handleDropdownChange(e.target.value, username)}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "200px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#fff",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
        >
          {statusList.map((item: any, index) => (
            <CustomMenuItem key={index} value={item.id}>
              {item.name}
            </CustomMenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  const handleCheckboxChange = (categoryId: number) => {
    setSearchButton(false);
    setSelectedRows([]);
    setSelectedUsernames([]);
    const selectedRow = props.updateSearchItems.find(
      (row: any) => row.userCategoryId === categoryId
    );

    if (selectedRow) {
      setSelectedRows([selectedRow]);
      setSelectedUsernames([categoryId]);
    }
  };

  const listItemTable = () => {
    if (props.updateSearchItems.length === 0) {
      return (
        <Typography
          sx={{ margin: "24px auto", color: "red", fontSize: "28px" }}
        >
          <b>{constants.NO_RECORDS_FOUND}</b>
        </Typography>
      );
    }
    return (
      <>
        <div style={{ overflowY: "auto" }}>
          <table className={styles.tableContainer}>
            <thead>
              <tr className={styles.headerTableRow}>
                <th className={styles.tableHorizontal}></th>
                <th className={styles.tableHorizontal}>Username</th>
                <th className={styles.tableHorizontal}>Name</th>
                <th className={styles.tableHorizontal}>Address</th>
                <th className={styles.tableHorizontal}>Email</th>
                <th className={styles.tableHorizontal}>Phone No</th>
                <th className={styles.tableHorizontal}>Details</th>
                <th className={styles.tableHorizontal}>Status</th>
              </tr>
            </thead>
            <tbody className={styles.tableBody} id="searchScmData">
              {userDetails?.map(
                (row: any, id: number) =>
                  row.categoryName != null &&
                  row.categoryName != "Steering Committee Member" && (
                    <tr key={id} className={styles.tableRow}>
                      <td
                        className={styles.tableDiagonal}
                        style={{
                          color: "#000",
                          fontWeight: 400,
                          textAlign: "start",
                        }}
                      >
                        <CustomCheckbox
                          checked={selectedRows.some(
                            (selectedRow) =>
                              selectedRow.userCategoryId === row.userCategoryId
                          )}
                          onChange={() => handleCheckboxChange(row.userCategoryId)}
                        />
                      </td>
                      <td
                        className={styles.tableDiagonal}
                        style={{
                          color: "#000",
                          fontWeight: 400,
                          textAlign: "start",
                        }}
                      // onClick={() => handleSignInNameClick(row)}
                      >
                        {row.username}
                      </td>
                      <td
                        className={styles.tableDiagonal}
                        style={{
                          color: "#000",
                          fontWeight: 400,
                          textAlign: "start",
                        }}
                      >
                        {`${row.firstname} ${row.middlename ? row.middlename + ' ' : ''}${row.lastname}`}
                      </td>
                      <td
                        className={styles.tableDiagonal}
                        style={{
                          color: "#000",
                          fontWeight: 400,
                          textAlign: "start",
                        }}
                      >
                        {getDevoteeAddress(row, false)}
                      </td>
                      <td
                        className={styles.tableDiagonal}
                        style={{
                          fontWeight: 400,
                          color: "#000",
                          textAlign: "start",
                        }}
                      >
                        {row.email}
                      </td>
                      <td
                        className={styles.tableDiagonal}
                        style={{
                          fontWeight: 400,
                          color: "#000",
                          textAlign: "start",
                        }}
                      >
                        {row.phonework}
                      </td>
                      <td
                        className={styles.tableDiagonal}
                        style={{
                          fontWeight: 400,
                          color: "#000",
                          textAlign: "start",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={() => handleDetailsClick(row)}
                      >
                        <p>Details</p>
                      </td>
                      <td
                        className={styles.tableDiagonal}
                        style={{
                          fontWeight: 400,
                          color: "#000",
                          textAlign: "start",
                        }}
                      >
                        {selectStatusDropdown(row.status, row.username)}
                      </td>
                    </tr>
                  )
              )}
            </tbody>
          </table>
        </div>
        {props.totalRecords > 20 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: "10px",
              marginTop: "3px",
            }}
          >
            <Pagination
              items={props.totalRecords}
              itemsPerPage={20}
              setPageNumber={props.setPageNumber}
              pageNumber={props.pageNumber}
            />
          </div>
        ) : (
          ""
        )}
        <Grid sx={{ marginTop: "10px" }}>
          <CommonButton
            className={styles.search}
            onClick={handleConfirm}
            disabled={searchButton || loading}
            id="search"
            type="submit"
          >
            {loading ? (
              <>
                <ClipLoader color="#fff" loading={loading} size={15} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  Loading...
                </span>
              </>
            ) : (
              "Confirm"
            )}
          </CommonButton>
        </Grid>
      </>
    );
  };

  const SuccessDialog = () => {
    return (
      <>
        <Dialog
          open={openSuccessDialog}
          onClose={handleSuccessDialogClose}
          aria-labelledby="cancel-dialog-title"
        >
          <div
            style={{
              backgroundColor: "#882E14",
              width: "562px",
            }}
          >
            <DialogTitle
              sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
            >
              {"SC Member Status"}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleSuccessDialogClose}
              sx={{
                position: "absolute",
                right: 24,
                top: 8,
                color: (theme: any) => theme.palette.grey[500],
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </div>
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img src="/images/successImage.svg" />
            <Typography style={{ fontWeight: "400", marginBottom: "20px" }}>
              <b>{confirmedUser}</b> status has now changed to {confirmedStatus}
            </Typography>
          </DialogContent>
        </Dialog>
      </>
    );
  };

  const userDetailsTableComponent = () => {
    const categories = Array.isArray(userDetailsDevoteeCategoryList) ? userDetailsDevoteeCategoryList : [];

    // Map categories to JSX elements with <br/> separators
    const categoriesWithLineBreaks = categories.map((category, index) => (
      <div key={index}>
        {category}{index < categories.length - 1 && <br />}
      </div>
    ));
    return (
      <Grid>
        {/* {userDetailsList?.map((user: any, index: any) => ( */}
        <table className={styles.tableDetailsTableContainer}>
          <tbody>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Sign-in Name</td>
              <td className={styles.contentTableColumn}>{userDetailsList.username}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Name</td>
              <td className={styles.contentTableColumn}>{`${userDetailsList.firstName} ${userDetailsList.middleName ? userDetailsList.middleName + ' ' : ''} ${userDetailsList.lastName}`} </td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Address</td>
              <td className={styles.contentTableColumn}>{getDevoteeAddress(userDetailsList)}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Home Phone</td>
              <td className={styles.contentTableColumn}>{userDetailsList.phoneResidence === null || userDetailsList.phoneResidence === "" ? "-" : userDetailsList.phoneResidence}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Work Phone</td>
              <td className={styles.contentTableColumn}>{userDetailsList.phoneWork === null || userDetailsList.phoneWork === "" ? "-" : userDetailsList.phoneWork}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Email</td>
              <td className={styles.contentTableColumn}>{userDetailsList.email === null || userDetailsList.email === "" ? "-" : userDetailsList.email}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Category</td>
              <td className={styles.contentTableColumn}><span style={{ fontWeight: 600 }}>{userDetailsList.defaultCategoryName}</span><br />
                {categoriesWithLineBreaks}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Date of Registration</td>
              <td className={styles.contentTableColumn}>{userDetailsList.dateOfRegistration === null || userDetailsList.dateOfRegistration === "" ? "-" : userDetailsList.dateOfRegistration}</td>
            </tr>
            <tr className={styles.headerTableRow}>
              <td className={styles.headerTableColumn}>Update Date</td>
              <td className={styles.contentTableColumn}>{userDetailsList.updateDate === null || userDetailsList.updateDate === "" ? "-" : userDetailsList.updateDate}</td>
            </tr>
          </tbody>
        </table>
        {/* ))} */}
      </Grid>
    );
  };

  const userDetailsDialogComponent = () => {
    return (
      <>
        <Dialog
          open={openUserDetailsDialog}
          onClose={handleUserDetailsDialogClose}
          aria-labelledby="cancel-dialog-title"
        >
          <div
            style={{
              backgroundColor: "#882E14",
              width: "600px",
            }}
          >
            <DialogTitle
              sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
            >
              {"Devotee Details"}
            </DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleUserDetailsDialogClose}
              sx={{
                position: "absolute",
                right: 24,
                top: 8,
                color: (theme: any) => theme.palette.grey[500],
              }}
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </div>
          <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            {/* {userDetailsTableComponent()} */}
            {loadingBounce ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <BounceLoader color="#22A699" loading={loadingBounce} size={45} />
                <span
                  style={{
                    marginLeft: "8px",
                    fontSize: "15px",
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Please wait...
                </span>
              </div>
            ) : (
              <div>
                {userDetailsTableComponent()}
                {/* {donationSummeryList.length > 0 ? (
                  poojaDetailsComponent()
                ) : (
                  <Typography sx={{ textAlign: "center" }}>No Data</Typography>
                )} */}
              </div>
            )}
          </DialogContent>
        </Dialog>
      </>
    )
  }

  return (
    <Box className={styles.updateScmMemberMainContainer}>
      <ToastComponent />
      {SuccessDialog()}
      {userDetailsDialogComponent()}
      <Grid>
        {props.showTableComponent && listItemTable()}
      </Grid>
    </Box>
  );
};

export default UpdateScmStatusComponent;